// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';

import { BaseDialog, Trash02Icon } from '@metarouter-private/mr-mui';

import { MrErrorModal } from '@ion/components';
import useConfirmDeleteModalProps from './useConfirmDeleteModalProps';
import ConfirmDeleteContent from './ConfirmDeleteContent';
import ConfirmDeleteActions from './ConfirmDeleteActions';

export default function ConfirmDeleteModal() {
  const {
    errorMsg,
    setErrorMsg,
    DialogProps,
    pipeline,
    loading,
    deployedIntegrations,
    deployedPipelineError,
    onClose,
    onDelete,
    setConfirmInputValue,
    deleteDisabled,
  } = useConfirmDeleteModalProps();

  if (errorMsg) {
    return (
      <MrErrorModal header="Error Deleting Pipeline" errorMessage={errorMsg} closeModal={() => setErrorMsg(false)} />
    );
  }

  return (
    <BaseDialog
      DialogProps={DialogProps}
      title={`Delete Pipeline ${pipeline.name}`}
      TitleIcon={Trash02Icon}
      content={
        <ConfirmDeleteContent
          clusterName={pipeline.cluster.name}
          loadingIntegrations={loading}
          deployedIntegrations={deployedIntegrations}
          integrationsLoadError={deployedPipelineError}
          writeKey={pipeline.writekey}
          onConfirmInputChange={setConfirmInputValue}
        />
      }
      actions={<ConfirmDeleteActions disabled={deleteDisabled} onConfirm={onDelete} onCancel={onClose} />}
    />
  );
}
